














































import {
  defineComponent, ref, computed, PropType,
} from '@vue/composition-api';
import FCImage from '~/components/FCImage.vue';

interface IItem {
  title: string;
  text: string;
}

interface ISlide {
  image: {
    filename: string;
    alt: string;
  };
  values: {
    title: string;
    subTitle: string;
    items: IItem[];
  };
  tabletUpImage: {
    filename: string;
    alt: string;
  };
}

export default defineComponent({
  name: 'PackageTabletUpCard',
  components: {
    FCImage,
  },
  props: {
    slide: {
      type: Object as PropType<ISlide>,
      required: true,
    },
  },
  setup(props) {
    const onHover = ref(false);

    function onMouseOver() {
      onHover.value = true;
    }
    function onMouseLeave() {
      onHover.value = false;
    }

    const isOnHover = computed(() => {
      if (onHover.value) {
        return {
          backgroundImage: `url(${props.slide.tabletUpImage.filename})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        };
      }

      return {};
    });

    return {
      onHover,
      onMouseOver,
      onMouseLeave,
      isOnHover,
    };
  },
});
